import { state } from 'ccstate'

export const isOpen$ = state(false)